const currency = SPREE_CURRENCY_SIGN

const ParamName = (data, param) => {
  if (!data || !data.variant_id || !param) {
    console.warn('Invalid parameters passed to ParamName:', { data, param })
    return ''
  }
  return `self_served_program[self_served_program_variants_attributes][${data.variant_id}][${param}]`
}

const PriceFormatter = (value) => {
  const num = Number(value)
  if (isNaN(num)) {
    console.warn('Invalid value passed to PriceFormatter:', value)
    return `${currency} 0.00`
  }
  const formatted = num.toFixed(2)
  return currency + Math.round(formatted * 100) / 100
}

const escapeHtml = (str) => {
  if (!str) return ''
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

const ProgramHead = (data, t) => {
  if (!data || !t) {
    console.warn('Missing required data for ProgramHead')
    return '<div class="basicProgram_row basicProgram_head">Error: Missing data</div>'
  }

  return `
    <div class="basicProgram_row basicProgram_head">
      <h3>${escapeHtml(data.size)}</h3>
      <div class="row justify-content-between align-items-center">
        <div class="col-3 col-md-4">
          <img src="${escapeHtml(data.image)}" alt="${escapeHtml(data.size)}" loading="lazy">
        </div>
        <div class="col-9 col-md-8 col-lg-7">
          <div class="basicProgram_unit">
            <span>${escapeHtml(t.unit_dimensions)}</span>
            <span><b>${escapeHtml(data.unit)}</b></span>
          </div>
          <div class="basicProgram_unit">
            <span>${escapeHtml(t.unit_price)}</span>
            <span><b>${PriceFormatter(data.price)}</b></span>
          </div>
        </div>
      </div>
      <button type="button"
              class="tooltip-btn icon-tooltip"
              data-bs-toggle="tooltip"
              aria-label="More information"
              title='${escapeHtml(data.description)}'>
      </button>
   </div>
  `
}

const ProgramSubsidy = (data, t) => {
  const isDisabled = data.in_stock_flag ? 'disabled' : ''
  const disabledClass = data.in_stock_flag ? 'is-disabled' : ''

  return `
    <div class="basicProgram_row basicProgram_subsidy">
      <input type="number" class="d-none" value="${data.variant_id}" name="${ParamName(data, 'variant_id')}">
      <div class="row justify-content-between">
        <div class="col-md-4">
          <h4><b>${escapeHtml(t.set_subsidy_title)}:</b></h4>
          <div class="grey-text smallerText">
            <span>${escapeHtml(t.set_subsidy_description)}</span>
            <button type="button"
              class="tooltip-btn icon-tooltip d-inline-block position-static"
              data-bs-toggle="tooltip"
              title='${escapeHtml(t.set_subsidy_tooltip)}'>
            </button>
          </div>
        </div>
        <div class="col-md-8 col-lg-7">
          <div class="range ${data.in_stock_flag ? 'disabled' : ''}" data-type="subsidy">
            <div class="range-left-side">
              <output id="customer-value-${data.variant_id}">
                ${PriceFormatter(data.price - data.subsidy)}
              </output>
              <span class="range-side-text">${escapeHtml(t.cost_customers)}</span>
            </div>
            <input type="range"
                   id="initial-subsidy-${data.variant_id}"
                   min="0"
                   max="${data.price}"
                   value="${data.price - data.subsidy}"
                   ${isDisabled}
            />
            <div class="range-right-side">
              <input id="subsidy-${data.variant_id}"
                     class="d-none"
                     name="${ParamName(data, 'subsidy')}"
                     type="number"
                     value="${data.subsidy}"
                     readonly
              >
              <input class="range-input-field subsidy-input-field-js ${disabledClass}"
                     id="subsidy-value-${data.variant_id}"
                     min="0"
                     max="${data.price}"
                     value="${PriceFormatter(data.subsidy)}"
                     ${isDisabled}
               />
              <span class="range-side-text">${escapeHtml(t.your_subsidy)}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  `
}

const ProgramQuantity = (data, t) => {
  return `
    <div class="basicProgram_row basicProgram_quantity ">
      <div class="row justify-content-between">
        <div class="col-md-4">
          <h4><b>${escapeHtml(t.set_quantity_title)}:</b></h4>
          <div class="grey-text smallerText">${escapeHtml(t.set_quantity_description)}</div>
        </div>
        <div class="col-md-8 col-lg-7">
          <div class="range" data-type="quantity">
             <div class="range-left-side">
               <output id="initial-quantity-output-${data.variant_id}" class="is-disabled">
                 ${data.min_quantity}
               </output>
               <span class="range-side-text">${escapeHtml(t.minimum_required_quantity)}</span>
             </div>
             <input type="range"
                    class="range-input"
                    id="initial-quantity-${data.variant_id}"
                    name="${ParamName(data, 'initial_quantity')}"
                    step="1"
                    min="${data.min_quantity}"
                    max="${data.max_quantity}"
                    value="${data.quantity}"
             />
             <div class="range-right-side">
               <input type="text"
                      class="range-input-field range-input-field-js"
                      id="quantity-value-${data.variant_id}"
                      min="${data.min_quantity}"
                      max="${data.max_quantity}"
                      value="${data.quantity}"
                      maxlength="3"
                      pattern="\\d*"
               />
               <span class="range-side-text">${escapeHtml(t.quantity)}</span>
             </div>
          </div>
        </div>
      </div>
    </div>
  `
}

const ProgramLimit = (data, t) => {
  const isChecked = data.limit === 1 ? 'checked' : ''

  return `
    <div class="basicProgram_row">
      <div class="row justify-content-between" data-limit="${data.variant_id}">
        <div class="col-md-4">
          <h4><b>${escapeHtml(t.set_limit_title)}:</b></h4>
          <div class="grey-text smallerText mb-5 m-md-0">${escapeHtml(t.set_limit_description)}</div>
        </div>
        <div class="col-md-8 col-lg-7">
          <div class="purchaseLimit">
            <div class="grey-text smallerText">${escapeHtml(t.why_change_limit)}</div>
            <button type="button"
                    class="tooltip-btn icon-tooltip"
                    data-bs-toggle="tooltip"
                    title='${escapeHtml(t.purchase_limit_tooltip)}'>
            </button>
          </div>
          <div class="basicProgram_limit bootstrapForm">
            <label class="checkbox">
              <input type="checkbox" id="limit-checkbox-${data.variant_id}" ${isChecked}>
              <label for="limit-checkbox-${data.variant_id}">${escapeHtml(t.purchase_limit)}</label>
            </label>
          </div>
          <div class="basicProgram_increaseLimit bootstrapForm">
            <div class="form-group">
              <label for="limit-${data.variant_id}">${escapeHtml(t.increase_limit)}:</label>
              <input type="number"
                     id="limit-${data.variant_id}"
                     class="required form-control"
                     name="${ParamName(data, 'purchase_limit')}"
                     min="1"
                     value="${data.limit}"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  `
}

const ProgramSubtotal = (data, t) => {
  return `
    <div class="basicProgram_subtotal">
      <div class="row justify-content-between">
        <div class="col-4">
          <h4>${escapeHtml(t.subtotal)}:</h4>
        </div>
        <div class="col-8 col-lg-7 text-end">
          <h4 id="subtotal-${data.variant_id}">${currency}${data.quantity * data.subsidy}</h4>
        </div>
      </div>
    </div>
  `
}

const CartTotal = (programs, total, t) => {
  return `
    <div class="cartTotal">
      <ul class="cartTotal_list">
        ${programs.map((el) => CartTotalItem(el)).join('')}
      </ul>
      <div class="cartTotal_fee">
        <div class="cartTotal_fee-label">${escapeHtml(t.monthly_subscription_fee)}</div>
        <div class="cartTotal_fee-value">${escapeHtml(t.subscription_fee_with_currency)}</div>
      </div>
      <div class="cartTotal_sum">
        <h4 class="mb-0"><b>${escapeHtml(t.cart_total)}</b></h4>
        <h3 class="mb-0">${PriceFormatter(total)}</h3>
      </div>
    </div>
  `
}

const CartTotalItem = (el) => {
  return `
    <li>
      <span>${escapeHtml(el.size)}</span>
      <span>${el.quantity} <i>X</i> ${PriceFormatter(el.subsidy)}</span>
    </li>
  `
}

const OrderDetails = {
  currentProgram: null,
  defaultState: true,
  orderDetailsVisible: false,
  selectedPrograms: [],
  t: null,
  total: null,

  ANIMATION_DURATION: 100,
  CART_TOTAL_DELAY: 0,

  _cache: {
    setDetailsBtn: null,
    cartTotal: null,
    orderDetailsHeader: null,
    processToCheckout: null,
    totalBudgetRest: null,
    budget: null
  },

  _validateData(data, requiredFields = ['variant_id']) {
    if (!data) return false
    return requiredFields.every(field => data[field] !== undefined && data[field] !== null)
  },

  _validateElement($element) {
    return $element && $element.length > 0
  },

  _initCache() {
    this._cache.setDetailsBtn = $('#set-details-btn')
    this._cache.cartTotal = $('#cart-total')
    this._cache.orderDetailsHeader = $('#order-details-header')
    this._cache.processToCheckout = $('#process-to-checkout')
    this._cache.totalBudgetRest = $('.totalBudget_rest')
    this._cache.budget = $('#budget')
  },

  _findProgramIndex(variantId) {
    return this.selectedPrograms.findIndex(program => program.variant_id === variantId)
  },

  _getNumericValue(selector, fallback = 0) {
    const value = $(selector).val()
    const parsed = parseInt(value, 10)
    return isNaN(parsed) ? fallback : parsed
  },

  append(html) {
    $(this.currentProgram).find('.basicProgram').append(html)
  },

  changeCardTotal(input, data) {
    const elementIndex = this._findProgramIndex(data.variant_id)
    if (elementIndex === -1) {
      console.warn(`Program with variant_id ${data.variant_id} not found in selectedPrograms`)
      return
    }

    if ($(input).closest('[data-type="subsidy"]').length) {
      this.selectedPrograms[elementIndex].subsidy = data.price - input.value
    } else {
      this.selectedPrograms[elementIndex].quantity = input.value
    }

    this.setCartTotal()
  },

  checkState() {
    if (!this._cache.setDetailsBtn) {
      this._initCache()
    }

    const hasSelectedPrograms = this.selectedPrograms.length > 0

    if (hasSelectedPrograms) {
      const hasRenderedDetails = this.selectedPrograms.some(program =>
        $(`#basic-program-${program.variant_id} .basicProgram`).length > 0
      )

      if (this.orderDetailsVisible || hasRenderedDetails) {
        this.orderDetailsVisible = true
        this._cache.orderDetailsHeader.add(this._cache.processToCheckout).show()
        setTimeout(() => this._cache.cartTotal.show(), this.CART_TOTAL_DELAY)
        this._cache.setDetailsBtn.hide()
      } else {
        this._cache.setDetailsBtn.show()
      }
    } else {
      this._cache.orderDetailsHeader
        .add(this._cache.cartTotal)
        .add(this._cache.processToCheckout)
        .hide()
      this._cache.setDetailsBtn.show()
      this._cache.totalBudgetRest.empty()
      this.orderDetailsVisible = false
    }
  },

  checkStatus(data) {
    if (!data || !data.variant_id) {
      console.warn('Invalid data provided to checkStatus')
      return
    }

    const programSelector = `#program-${data.variant_id}`
    $(programSelector).off('change.orderDetails')

    const existingIndex = this._findProgramIndex(data.variant_id)

    if (data.checked && existingIndex === -1) {
      this.selectedPrograms.push(data)
      this.render(data)
      $(document).ready(() => this.disableSubmit())
    }

    $(programSelector).on('change.orderDetails', (event) => {
      const $target = $(event.target)
      const programItem = $target.closest('[data-role="self_program_item"]')
      const isChecked = $target.is(':checked')

      if (isChecked) {
        const existingIndex = this._findProgramIndex(data.variant_id)
        if (existingIndex === -1) {
          programItem.addClass('checked')
          this.selectedPrograms.push(data)
          if (!this.defaultState && this.orderDetailsVisible) {
            this.init(`#basic-program-${data.variant_id}`, this.t).render(data)
            this.checkState()
          }
        }
      } else {
        programItem.removeClass('checked')
        this.destroy(data)
      }

      this._updateSetDetailsButton()
      this.setCartTotal()

      if (this.selectedPrograms.length === 0) {
        this.disableSubmit()
        this._cache.budget.val('')
      }
    })
  },

  _updateSetDetailsButton() {
    if (!this._cache.setDetailsBtn) {
      this._initCache()
    }
    this._cache.setDetailsBtn.prop('disabled', this.selectedPrograms.length === 0)
  },

  destroy(data) {
    if (!this._validateData(data)) {
      console.warn('Invalid data provided to destroy:', data)
      return
    }

    this.selectedPrograms = this.selectedPrograms.filter((item) => item.variant_id !== data.variant_id)
    this.init(`#basic-program-${data.variant_id}`, this.t)

    const $currentProgram = $(this.currentProgram)
    if (this._validateElement($currentProgram)) {
      $currentProgram.empty()
    }

    this.checkState()
  },

  disableSubmit() {
    const submitButtons = document.querySelectorAll('#selfServedForm button[data-type="submit"]')
    const shouldDisable = this.selectedPrograms.length === 0

    submitButtons.forEach((button) => {
      button.disabled = shouldDisable
    })
  },

  handleRangeChange(data) {
    if (!data || !data.variant_id) {
      console.warn('Invalid data provided to handleRangeChange')
      return
    }

    const programSelector = `#basic-program-${data.variant_id}`
    const $program = $(programSelector)

    $program.find('input[type="range"], .range-input-field.range-input-field-js').each(function () {
      if (typeof handleInputChange === 'function') {
        handleInputChange(this)
      }

      $(this).off('change.rangeHandler').on('change.rangeHandler', function () {
        const value = this.value
        const id = data.variant_id
        const price = data.price
        const $rangeSubsidy = $(this).closest('[data-type="subsidy"]')

        if ($rangeSubsidy.length) {
          $rangeSubsidy.find(`#customer-value-${id}`).text(PriceFormatter(value))
          $rangeSubsidy.find(`#subsidy-value-${id}`).val(PriceFormatter(price - value))
          $rangeSubsidy.find(`#subsidy-${id}`).val(price - value)
        }

        if (typeof handleInputChange === 'function') {
          handleInputChange(this)
        }
        OrderDetails.setSubtotal(this, data)
        OrderDetails.changeCardTotal(this, data)
      })
    })
  },

  init(el, translations) {
    if (!el || !translations) {
      console.warn('Invalid parameters provided to init')
      return this
    }

    this.currentProgram = el
    this.t = translations
    this.defaultState = this.selectedPrograms.length === 0
    return this
  },

  programDetails(data) {
    if (!data || !this.t) {
      console.warn('Invalid data or translations in programDetails')
      return
    }

    const t = this.t
    this.append(ProgramHead(data, t))
    this.append(ProgramSubsidy(data, t))
    this.append(ProgramQuantity(data, t))
    this.append(ProgramLimit(data, t))
    this.append(ProgramSubtotal(data, t))
  },

  purchaseLimit(data) {
    if (!data || !data.variant_id) {
      console.warn('Invalid data provided to purchaseLimit')
      return
    }

    const id = data.variant_id
    const $checkbox = $(`#limit-checkbox-${id}`)
    const $checkboxWrapper = $checkbox.closest('[data-limit]').find('.basicProgram_increaseLimit')
    const $limitInput = $(`#limit-${id}`)

    const checkState = () => {
      if ($checkbox.is(':checked')) {
        $checkboxWrapper.hide()
        $limitInput.val('1')
      } else {
        $checkboxWrapper.show()
      }
    }

    checkState()
    $checkbox.off('change.purchaseLimit').on('change.purchaseLimit', checkState)
  },

  render(data) {
    if (!data || !this.currentProgram) {
      console.warn('Invalid data or currentProgram in render')
      return
    }

    $(this.currentProgram).append('<div class="basicProgram"></div>')
    this.programDetails(data)
    this.handleRangeChange(data)
    this.purchaseLimit(data)

    $(document).ready(() => {
      if (typeof initTooltip === 'function') {
        initTooltip()
      }
    })
  },

  resetData() {
    this.selectedPrograms = []
    this.total = null
    this.currentProgram = null
    this.orderDetailsVisible = false
    this._cache = {}
  },

  setCartTotal() {
    if (!this.t || !this.t.subscription_fee) {
      console.warn('Missing translations or subscription_fee in setCartTotal')
      return
    }

    const subscriptionFee = Number(this.t.subscription_fee) || 0
    this.total = this.selectedPrograms.reduce((acc, el) => {
      const quantity = Number(el.quantity) || 0
      const subsidy = Number(el.subsidy) || 0
      return acc + (quantity * subsidy)
    }, 0) + subscriptionFee

    if (!this._cache.cartTotal) {
      this._initCache()
    }

    this._cache.cartTotal.empty().append(CartTotal(this.selectedPrograms, this.total, this.t))
  },

  setOrderDetails(event) {
    if (event) {
      event.preventDefault()
    }

    this.orderDetailsVisible = true

    this.selectedPrograms.forEach((item) => {
      if (!item || !item.variant_id) {
        console.warn('Invalid item in selectedPrograms')
        return
      }

      const el = `#basic-program-${item.variant_id}`
      const $el = $(el)

      if ($el.contents().length === 0) {
        this.init(el, this.t).render(item)
      }
    })

    this.checkState()

    const $stepSecond = $('.stepSecond')
    const $orderDetailsHeader = $('#order-details-header')

    if ($stepSecond.length > 0 && $orderDetailsHeader.length > 0) {
      $('html, body').animate({
        scrollTop: $orderDetailsHeader.offset().top
      }, 'slow')
    }

    this.disableSubmit()
  },

  setSubtotal(input, data) {
    if (!input || !data || !data.variant_id) {
      console.warn('Invalid parameters provided to setSubtotal')
      return
    }

    const id = data.variant_id
    const quantity = this._getNumericValue(`#quantity-value-${id}`) ||
      this._getNumericValue(`#initial-quantity-${id}`)
    const subsidy = this._getNumericValue(`#subsidy-${id}`)
    const subtotal = PriceFormatter(subsidy * quantity)

    $(input).closest(`#basic-program-${id}`).find(`#subtotal-${id}`).text(subtotal)
  }
}

$(document).on('input', '.subsidy-input-field-js', function () {
  try {
    const $this = $(this)
    const inputValue = $this.val()
    const $range = $this.parents('.range')
    const $rangeInput = $range.find('input[type="range"]')
    const $subsidyField = $this.siblings('input')

    if (!inputValue) return

    const numericValue = inputValue.replace(/\D/g, '')

    if (!numericValue) return

    $subsidyField.val(numericValue)
    $this.val(`${currency}${numericValue}`)

    const maxValue = Number(this.max) || 0
    const newRangeValue = maxValue - Number(numericValue)
    const clampedValue = Math.max(0, newRangeValue)

    $rangeInput.val(clampedValue)

    if (typeof handleInputChange === 'function') {
      handleInputChange($rangeInput[0])
    }

    $rangeInput.trigger('input')

    const $customerValueOutput = $range.find(`#customer-value-${$subsidyField.attr('name').match(/\[(\d+)\]/)[1]}`)
    if ($customerValueOutput.length) {
      $customerValueOutput.text(PriceFormatter(clampedValue))
    }

  } catch (error) {
    console.error('Error in subsidy input handler:', error)
  }
})

window.OrderDetails = OrderDetails
